import React from "react";
import styled from "styled-components";

// Components
import ServiceBox from "../Elements/ServiceBox";

export default function Services() {
  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Awesome Services</h1>
          </HeaderInfo>

          {/* Row 1: Data Cleansing, Data Analysis, NEW: ML & Regression */}
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Data Cleansing"
                subtitle="Data cleansing is a critical step in data analysis. By removing errors and inconsistencies, we improve data quality so insights and decisions are trustworthy."
              />
            </ServiceBoxWrapper>

            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Data Analysis"
                subtitle="We examine, transform, and model data to extract meaning—summarizing datasets, identifying trends and patterns, and answering business questions clearly."
              />
            </ServiceBoxWrapper>

            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Machine Learning & Regression Analysis"
                subtitle={
                  "Classifier: predicts categories (e.g., default vs. no default) using models like Logistic Regression, Random Forest, or KNN. " +
                  "Regression: predicts numeric values (e.g., price, demand) with Linear, Ridge/Lasso, or tree-based models. We handle feature engineering, training/validation, and explainability."
                }
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>

          {/* Row 2 starts with Training Events, then your extra services */}
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Training Events"
                subtitle="Hands-on workshops tailored to your team in Tableau, MS Power BI, and Excel—covering data prep, modeling, visualization, and sharing best practices."
              />
            </ServiceBoxWrapper>

            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Custom Software Development"
                subtitle="We develop tailor-made software solutions aligned to your business goals and workflows."
              />
            </ServiceBoxWrapper>

            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Mobile App Development"
                subtitle="High‑performance iOS/Android apps and cross‑platform solutions using Flutter and React Native."
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>

          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Web Development"
                subtitle="Responsive, modern websites and web apps using React.js, Node.js, Python, and current frameworks."
              />
            </ServiceBoxWrapper>

            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Cloud Solutions"
                subtitle="Cloud consulting, migration, and management to leverage platforms like GCP and AWS efficiently."
              />
            </ServiceBoxWrapper>

            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="UI/UX and Graphic Design"
                subtitle="Intuitive interfaces and compelling visuals that elevate user experience and brand identity."
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>

          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Consulting and Strategy"
                subtitle="Practical guidance to make smarter technology and data decisions that drive business outcomes."
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 33%;
  margin-right: 5%;
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
    margin-right: 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
